import { Categories, Pages } from "./Pages";
import { SlotParamsService } from "../services/SlotAppParamsService";

export interface PageSEOInterface {
  Name: string;
  URLAlias: string;
  category?: boolean;
  OnPageTitle: string;
  OnPageDescription: string;
  MetaHTMLTitle: string;
  MetaHTMLDescription: string;
  MetaKeywords?: string;
  Arena5Slug: Pages | Categories;
  OgTitle?: string;
  OgDescription?: string;
}

export const PagesSEO: PageSEOInterface[] = [
  {
    Name: "Home Page",
    URLAlias: "",
    OnPageTitle: "Games",
    OnPageDescription: "",
    MetaHTMLTitle:
      "Free Online Games - Internet Game Sites, Play Puzzles, Cards, Brain Games",
    MetaHTMLDescription:
      "Daily games and puzzles to sharpen your skills. AARP has new free games online such as Mahjongg, Sudoku, Crossword Puzzles, Solitaire, Word games and Backgammon! Register on AARP.org and compete against others to find out if you are a Top Gamer.",
    Arena5Slug: Pages.Home,
    OgTitle: "Games",
    OgDescription:
      "Daily games and puzzles to play and compete against others.",
  },
  {
    Name: "All Games",
    URLAlias: "all-games",
    category: true,
    OnPageTitle: "All Games",
    OnPageDescription: "",
    MetaHTMLTitle: "See All the Online Games Available from AARP",
    MetaHTMLDescription:
      "On this page is a listing of all the online games and puzzles available for you to play and enjoy. Have fun and start playing today!",
    Arena5Slug: Pages.All,
    OgTitle: "All AARP Games",
    OgDescription:
      "All the online games and puzzles available for you to play.",
  },
  {
    Name: "Arcade Games",
    URLAlias: "arcade",
    category: true,
    OnPageTitle: "Arcade Games",
    OnPageDescription: "",
    MetaHTMLTitle: "Arcade Games Online - Play Free Online Arcade Games",
    MetaHTMLDescription:
      "Play and compete online with AARP's addicting Arcade Games such as Crossword Puzzles, Solitaire, Bubble Shooter games, Slots and many more!",
    Arena5Slug: Categories.Arcade,
    OgTitle: "Arcade Games",
    OgDescription:
      "Arcade games such as  Bubble Shooter, Slots, and many more!",
  },
  {
    Name: "Card Games",
    URLAlias: "card",
    category: true,
    OnPageTitle: "Card Games",
    OnPageDescription: "",
    MetaHTMLTitle: "Card Games You Can Play and Enjoy Online Today",
    MetaHTMLDescription:
      "A full listing of card games that are available today such as Solitaire and Bridge. Find the card game that is best for you and play now for free!",
    Arena5Slug: Categories.Card,
    OgTitle: "Card Games",
    OgDescription:
      "A full listing of card games that are available for you to play.",
  },
  {
    Name: "Mahjongg",
    URLAlias: "mahjongg",
    category: true,
    OnPageTitle: "Mahjongg Games",
    OnPageDescription: "",
    MetaHTMLTitle: "Mahjongg - See and Play All the AARP Mahjongg Games",
    MetaHTMLDescription:
      "If you like playing Mahjongg for free, AARP has the games you will like to play online. Play Mahjongg Dark Dimensions and other great Mahjongg games.",
    Arena5Slug: Categories.Mahjongg,
    OgTitle: "Mahjongg",
    OgDescription:
      "Play Mahjongg Dark Dimensions and other great Mahjongg games.",
  },
  {
    Name: "Member Games",
    URLAlias: "members",
    category: true,
    OnPageTitle: "Member Games",
    OnPageDescription: "",
    MetaHTMLTitle: "Puzzles and Games That Are Available For AARP Members",
    MetaHTMLDescription:
      "Register today and play additional member only games! All AARP member games, crosswords, and puzzles can be found here. Members get more games.",
    Arena5Slug: Categories.Members,
    OgTitle: "Games for AARP Members",
    OgDescription:
      "All AARP member games, crosswords, and puzzles can be found here.",
  },
  {
    Name: "New Games",
    URLAlias: "new-games",
    category: true,
    OnPageTitle: "New Games",
    OnPageDescription: "",
    MetaHTMLTitle: "Discover and Play New Online Games and Puzzles Here",
    MetaHTMLDescription:
      "The latest AARP games, crosswords and puzzles can be found here. Explore these games and play to get on the leaderboard early. Play now for free!",
    Arena5Slug: Categories.New,
    OgTitle: "New Games and Puzzles",
    OgDescription:
      "The latest AARP games, crosswords and puzzles can be found here.",
  },
  {
    Name: "Recently Played",
    URLAlias: "recently-played",
    category: true,
    OnPageTitle: "Recently Played Games",
    OnPageDescription: "",
    MetaHTMLTitle: "Recently Played Online Games and Puzzles from AARP",
    MetaHTMLDescription:
      "All your AARP recently played games, crosswords, and puzzles can be found here. Continue playing your favorite online game or puzzle now for free!",
    Arena5Slug: Pages.RecentlyPlayed,
    OgTitle: "Recently Played Games",
    OgDescription: "Continue playing your favorite recently played game here!",
  },
  {
    Name: "Solitaire",
    URLAlias: "solitaire",
    category: true,
    OnPageTitle: "",
    OnPageDescription: "",
    MetaHTMLTitle: "Solitaire Card Games Are Here - Play Classic Solitaire",
    MetaHTMLDescription:
      "You can find all AARP's solitaire card games to play here. Play for fun, play for free. Enjoyable games like spider solitaire and FreeCell solitaire!",
    Arena5Slug: Categories.Solitaire,
    OgTitle: "Solitaire Card Games",
    OgDescription:
      "Find all the solitaire card games to play here and play for fun.",
  },
  {
    Name: "Strategy",
    URLAlias: "strategy",
    category: true,
    OnPageTitle: "Solitaire Games",
    OnPageDescription: "",
    MetaHTMLTitle: "Strategy Games For You To Play. How Strategic are You?",
    MetaHTMLDescription:
      "Test your strategy skills by playing fun games like Spellbound, Mahjongg, or Sudoku and see if you can make it to the AARP game leaderboard.",
    Arena5Slug: Categories.Strategy,
    OgTitle: "Strategy Games",
    OgDescription:
      "Test your strategy skills and see if you can make the leaderboard.",
  },
  {
    Name: "Daily Games",
    URLAlias: "daily-games",
    category: true,
    OnPageTitle: "Daily Games",
    OnPageDescription: "",
    MetaHTMLTitle: "Daily Games - Play A New Game Online Every Day",
    MetaHTMLDescription:
      "Play a new daily game online, every day. Crosswords, Jigsaw, Sudoku and much more. Each puzzle has a new game of the day to keep you coming back.",
    MetaKeywords: "games, daily games, crosswords, puzzles",
    Arena5Slug: Categories.Daily,
    OgTitle: "A New Game Every Day",
    OgDescription:
      "A new daily game every day. Crosswords, Jigsaw, Sudoku and more.",
  },
  {
    Name: "AARP Rewards",
    URLAlias: "rewards-games",
    category: true,
    OnPageTitle: "AARP Rewards",
    OnPageDescription: "",
    MetaHTMLTitle: "AARP Rewards Games Online - Play to Get Rewards",
    MetaHTMLDescription:
      "Get rewarded for playing games. The most fun way to earn points for AARP Rewards is by solving your favorite crossword puzzles, and other fun games.",
    MetaKeywords: "games, rewards, crosswords, earn points",
    Arena5Slug: Categories.Rewards,
    OgTitle: "AARP Rewards - Games",
    OgDescription:
      "Get rewarded for playing games and solving your favorite puzzles.",
  },
  {
    Name: "Atari®",
    URLAlias: "atari-games",
    category: true,
    OnPageTitle: "Atari®",
    OnPageDescription: "",
    MetaHTMLTitle: "Atari Video Games - Classics Available To Play Online",
    MetaHTMLDescription:
      "Play classic Atari video games free online from AARP games. Enjoy retro arcade games like Pong, Breakout, Centipede, Missile Command and Asteroids.",
    Arena5Slug: Categories.Atari,
    OgTitle: "Atari Video Games",
    OgDescription:
      "Enjoy retro arcade games like Pong, Centipede, and Asteroids.",
  },
  {
    Name: "Puzzles",
    URLAlias: "puzzles",
    category: true,
    OnPageTitle: "Puzzles",
    OnPageDescription: "",
    MetaHTMLTitle: "Puzzles - Free Puzzles and Games for You To Play Today",
    MetaHTMLDescription:
      "Take a look at all puzzles available for you to play and enjoy. These include Jigsaw Puzzles, Word Puzzles including Sudoku and Word Search games.",
    Arena5Slug: Categories.Puzzles,
    OgTitle: "Puzzles",
    OgDescription:
      "Jigsaw and Word Puzzles including Sudoku and Word Search games.",
  },
  {
    Name: "Word & Trivia",
    URLAlias: "word",
    category: true,
    OnPageTitle: "Word & Trivia",
    OnPageDescription: "",
    MetaHTMLTitle: "Word Games and Crossword Puzzles - Solve a Puzzle Today",
    MetaHTMLDescription:
      "Enjoy playing word search game or solving a crossword puzzle that range from easy to difficult. All word games and crossword puzzles are free to play.",
    Arena5Slug: Categories.Word,
    OgTitle: "Word Games and Crossword Puzzles",
    OgDescription:
      "Enjoy playing word search game or solving a crossword puzzle.",
  },
  {
    Name: "Help Page",
    URLAlias: "help",
    OnPageTitle: "Help",
    OnPageDescription: "",
    MetaHTMLTitle: "Help Center For Games With FAQ's from AARP",
    MetaHTMLDescription:
      "Get AARP games help here. AARP games can be played online. They are fun and engaging. More about AARP Games with our online help page.",
    Arena5Slug: Pages.Help,
    OgTitle: "Games Help",
    OgDescription:
      "Get AARP games help here. Games that are fun and engaging. ",
  },
  {
    Name: "Juegos",
    URLAlias: "juegos-espanol",
    category: true,
    OnPageTitle: "Juegos",
    OnPageDescription: "",
    MetaHTMLTitle: "Juegos gratis - crucigramas, rompecabezas y más",
    MetaHTMLDescription:
      "Diviértete gratis y al instante con los juegos en línea más populares de AARP y a la vez  desarrolla tu vocabulario con crucigramas en español.",
    Arena5Slug: Categories.Juegos,
    OgTitle: "Juegos gratis",
    OgDescription:
      "Diviértete gratis y al instante con los juegos en línea más populares.",
  },
  {
    Name: "Staying Sharp",
    URLAlias: "staying-sharp",
    category: true,
    OnPageTitle: "Staying Sharp",
    OnPageDescription: "",
    MetaHTMLTitle: "AARP Members Have Access To More Staying Sharp Games",
    MetaHTMLDescription:
      "Make sure you have time for fun games and puzzles with topics such as trivia and word challenges. These exclusive Staying Sharp games are included with AARP membership.",
    MetaKeywords: "Staying Sharp",
    Arena5Slug: Categories.StayingSharp,
    OgTitle: "Staying Sharp Games",
    OgDescription:
      "Make sure you have time for fun to enjoy games and puzzles",
  },
];
